import { Icon, TextField, Title } from '..';
import { useTranslation } from '../../../hooks/translations/TranslationProvider';
import { COLOURS } from '../../../utils/consts';

import './genericError.css';

const GenericError = (error: any) => {
    const { t } = useTranslation();

    const { error: errorData } = error;

    if (errorData.response?.status === 401) {
        return null;
    }

    if (errorData && errorData.response?.status === 404) {
        return (
            <div className="generic-error">
                <Icon name="bx-error" color={COLOURS.RED} size="50px" />
                <Title text="404 - Resource not found" size="l" />
                <TextField>This record has been removed</TextField>
            </div>
        );
    }

    return (
        <div className="generic-error">
            <Icon name="bx-error" color={COLOURS.RED} size="50px" />
            <Title text={t('errors.genericErrorTitle')} size="l" />
            <TextField>{t('errors.genericError')}</TextField>
        </div>
    );
};

export default GenericError;
